import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
    getEmployes,
    getStatus,
    getTypes,
    getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";


class ServiceAdd extends React.Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.state = {
            branches: [],
            employes: [],
            customers: [],
            vehicles: [],
            types: [],
            status: [],
            brands: [],
            models: [],
            selectedBrand: '',
            selectedModel: '',
            loading: false,
            isLoad: true,
            carImageFile: null,
            isCustomerHasPID: false,
            pDataloading: false,
            formData: {
                operationData: {
                    assigned_employee_id: '',
                    operation_type_id: '',
                    description: '',
                    statu_id: ''
                },
                vehicleData: {
                    vehicle_id: '',
                    brand: '',
                    model: '',
                    plate: '',
                    year: '',
                    km: '',
                    chassis_no: '',
                    engine_no: '',
                    package_name: '',
                    engine_size: '',
                    key_no: '',
                    details: '',
                    vehicleImages: '',
                    gear_type: '',
                },
                customerData: {
                    customer_id: '',
                    name: '',
                    surname: '',
                    phone: '',
                    address: '',
                    email: '',
                    save_parasut: 0,
                },
                vehicleDates: {
                    maintenance_date: '',
                    next_maintenance_date: '',
                    inspection_date: '',
                    next_inspection_date: ''
                }
            }
        }
    }
    async componentDidMount() {
        try {
            this.getBrands();
            this.setState({
                branches: await getBranches(),
                employes: await getEmployes(),
                types: await getTypes(),
                customers: await getCustomers(),
                status: await getStatus()
            }, () => {
                this.setState({ isLoad: false });
            });
        } catch (e) {
            this.setState({ isLoad: false })
            throw e;
        }
    }

    getBrands = async () => {
        const response = await apiCall('business/vehicle/get-brands', 'get', null);
        const brandOptions = response.map(brand => ({
            value: brand.id,
            label: brand.name
        }));
        this.setState({ brands: brandOptions });
    }

    handleBrandChange = async (selectedOption) => {
        const brand_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                vehicleData: {
                    ...prevState.formData.vehicleData,
                    brand: brand_id,
                    model: ""
                }
            },
            selectedBrand: option,
            models: []
        }));

        if (brand_id) {
            try {
                const response = await apiCall(`business/vehicle/get-models/${brand_id}`, 'get', null);

                const modelOptions = response.map(model => ({
                    value: model.id,
                    label: model.name
                }));
                this.setState({ models: modelOptions });
            } catch (error) {
                console.error("Modelleri alırken hata oluştu:", error);
            }
        }
    }
    handleModelChange = async (selectedOption) => {
        const model_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                vehicleData: {
                    ...prevState.formData.vehicleData,
                    model: model_id
                }
            },
            selectedModel: option,
        }));
    }

    getBrandByName = async (brand) => {
        const response = await apiCall('business/vehicle/get-brands-by-name', 'post', { brand });
        if (!response || !response.id) {
            return null;
        }

        const option = { value: response.id, label: response.name };
        const models = await apiCall(`business/vehicle/get-models/${response.id}`, 'get', null);
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                vehicleData: {
                    ...prevState.formData.vehicleData,
                    brand: response.id,
                    model: ''
                }
            },
            selectedBrand: option,
            selectedModel: '',
            models: models.map(item => ({ value: item.id, label: item.name }))
        }));

        return response.id;
    }

    getModelByName = async (brandId, model) => {
        const response = await apiCall(`business/vehicle/get-models-by-name/${brandId}`, 'post', { model });
        if (!response || !response.id) {
            return false;
        }

        const option = { value: response.id, label: response.name };
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                vehicleData: {
                    ...prevState.formData.vehicleData,
                    model: response.id
                }
            },
            selectedModel: option
        }));

        return true;
    }

    getVehiclesByCustomer = async (customerID) => {
        if (!customerID) {
            this.setState({ vehicles: '' });
            return;
        }
        try {
            const response = await apiCall('business/vehicle/get-by-id/' + customerID, 'get', null);
            this.setState({ vehicles: response });
        } catch (e) {

        }
    }
    handleButtonClick = () => {
        this.fileInputRef.current.click();
    };


    handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.getVehiclesDataWithAI(file);
        }
        event.target.value = null;
    };
    getVehiclesDataWithAI = async (file) => {
        try {
            Swal.fire({
                title: 'Resim işleniyor...',
                text: 'Lütfen bekleyin, işleminiz devam ediyor.',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('apikey', process.env.REACT_APP_EYETRAFFIC_API_KEY);
            const response = await axios.post('https://trafficeye.ai/recognition', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'apikey': process.env.REACT_APP_EYETRAFFIC_API_KEY
                }
            });
            const data = response.data.data;

            if (data && data.combinations && data.combinations.length > 0) {
                const vehicleInfo = data.combinations[0].roadUsers[0];
                const isInvalidImage = vehicleInfo.plates[0].type.value === "UNK" || vehicleInfo.plates[0].text.score < 0.5;
                if (isInvalidImage) {
                    Swal.close();
                    Swal.fire({
                        title: 'Uyarı',
                        text: 'Gönderilen resim uygun değil. Lütfen bir araç resmi yükleyiniz veya manuel kayıt giriniz!',
                        icon: 'warning',
                        confirmButtonText: 'Tamam'
                    });
                    return;
                }
                const plate = vehicleInfo.plates[0].text && vehicleInfo.plates[0].text.value ? vehicleInfo.plates[0].text.value : "Bulunamadı";
                const brand = vehicleInfo.mmr.make && vehicleInfo.mmr.make.value ? vehicleInfo.mmr.make.value : "Bulunamadı";
                const model = vehicleInfo.mmr.model && vehicleInfo.mmr.model.value ? vehicleInfo.mmr.model.value : "Bulunamadı";
                //const color = vehicleInfo.mmr.color.value;
                const generation = vehicleInfo.mmr.generation.value;
                //const category = vehicleInfo.mmr.category.value;
                console.log(generation);

                const brandId = brand !== "Bulunamadı" ? await this.getBrandByName(brand) : null;
                const modelFound = brandId && model !== "Bulunamadı"
                    ? await this.getModelByName(brandId, model)
                    : false;

                if (!brandId || !modelFound) {
                    Swal.close();
                    Swal.fire({
                        title: 'Uyarı',
                        text: 'Tanımlanan marka veya model araç veritabanında bulunamadı. Lütfen marka ve modeli manuel seçiniz.',
                        icon: 'warning',
                        confirmButtonText: 'Tamam'
                    });
                    this.setState(prevState => ({
                        formData: {
                            ...prevState.formData,
                            vehicleData: {
                                ...prevState.formData.vehicleData,
                                plate,
                                gen: generation,
                                brand: brandId || '',
                                model: ''
                            }
                        },
                        selectedBrand: brandId ? prevState.selectedBrand : '',
                        selectedModel: '',
                        models: brandId ? prevState.models : []
                    }));
                    return;
                }

                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        vehicleData: {
                            ...prevState.formData.vehicleData,
                            plate,
                            gen: generation
                        }
                    }
                }));
                Swal.close();
                Swal.fire({
                    title: 'Araç Bilgileri',
                    html: `
                        <p><strong>Plaka:</strong> ${plate}</p>
                        <p><strong>Marka:</strong> ${brand}</p>
                        <p><strong>Model:</strong> ${model}</p>
                        <p style="margin-top: 10px;"><strong>Lütfen yukarıda yer alan araç bilgilerinin doğruluğunu kontrol ediniz.</strong></p>
                      `,
                    icon: 'info',
                    confirmButtonText: 'Tamam'
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: 'Araç Bilgileri',
                    text: 'Gönderilen resim uygun değil. Lütfen bir araç resmi yükleyiniz.',
                    icon: 'info',
                    confirmButtonText: 'Tamam'
                });
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                title: 'Araç Bilgileri',
                text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
                icon: 'error',
                confirmButtonText: 'Tamam'
            });
            console.error(error);

        }
    }
    getCustomerParasutData = async (customer_id) => {
        this.setState({ pDataloading: true })
        try {
            const response = await apiCall('business/customer/check-parasut/' + customer_id, 'get', null);
            if (response) {
                const value = !!response.p_id;
                if (value) {
                    this.setState(prevState => ({
                        formData: {
                            ...prevState.formData,
                            customerData: {
                                ...prevState.formData.customerData,
                                save_parasut: 0
                            }
                        },
                    }))

                }
                this.setState({ isCustomerHasPID: value });

            }
            this.setState({ pDataloading: false })
        } catch (e) {
            this.setState({ pDataloading: false })
            console.error(e)
        }
    }
    handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;

        if (name === "customerData.customer_id") {
            this.getVehiclesByCustomer(value);
            this.getCustomerParasutData(value);
        }

        const path = name.split('.');

        this.setState(prevState => {
            let updatedData = { ...prevState.formData };
            let currentLevel = updatedData;

            for (let i = 0; i < path.length - 1; i++) {
                if (!currentLevel[path[i]]) {
                    currentLevel[path[i]] = {};
                }
                currentLevel = currentLevel[path[i]];
            }

            currentLevel[path[path.length - 1]] = type === "checkbox" ? checked : (files ? files : value);

            return { formData: updatedData };
        });
    }


    handleSubmit = async (e) => {
        e.preventDefault();
        const { formData } = this.state;
        this.setState({ loading: true });
        const serviceFormData = new FormData();
        const appendFormData = (data, root = '') => {
            Object.keys(data).forEach(key => {
                const formKey = root ? `${root}[${key}]` : key;
                if (typeof data[key] === 'object' && data[key] !== null && !(data[key] instanceof File)) {
                    appendFormData(data[key], formKey);
                } else {
                    serviceFormData.append(formKey, data[key]);
                }
            });
        };

        appendFormData(formData);
        try {
            const response = await apiCall('business/operation/add', 'post', serviceFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
            console.log(e.response.data.errors);

        }
    }
    render() {
        const { branches, employes, types, loading, status, customers, vehicles, brands, models, selectedBrand, selectedModel, isCustomerHasPID, pDataloading } = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
                        <div className="loader"
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="m-t-30">
                                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Servis Ekle"
                            Breadcrumb={[
                                { name: "Servisler", navigate: "services" },
                                { name: "Yeni Servis Kaydı", navigate: "" },
                            ]}
                        />
                        <form onSubmit={this.handleSubmit} encType='multipart/form-data'>
                            <div className="row clearfix">
                                <div className="col-lg-12 col-md-12">
                                    <div className="card">
                                        <div className="body" style={{
                                            padding: '20px',
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffeeba',
                                            borderRadius: '5px'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <i className="fa fa-exclamation-circle" style={{
                                                    color: '#856404',
                                                    fontSize: '24px',
                                                    marginRight: '10px'
                                                }}></i>
                                                <span className="text-danger" style={{
                                                    color: '#856404',
                                                    fontSize: '20px',
                                                    fontWeight: 'bold'
                                                }}>Uyarı</span>
                                            </div>
                                            <p style={{
                                                marginTop: '15px',
                                                color: '#856404',
                                                fontSize: '16px',
                                                lineHeight: '1.5'
                                            }}>
                                                İşletmenizin başarısı ve müşteri memnuniyetini en üst seviyeye çıkarmak
                                                için servis kaydını oluştururken tüm alanları eksiksiz doldurmanız çok
                                                önemlidir.
                                                Bu, hem veri bütünlüğünü korumanızı sağlayacak hem de müşterilerinizle
                                                daha etkili bir iletişim kurmanıza yardımcı olacaktır.
                                                Ayrıca, gelecekteki güncellemelerle gelen yeni özelliklerden tam
                                                anlamıyla faydalanabilmeniz için detaylı bilgiler büyük önem taşır.
                                                Lütfen tüm bilgileri eksiksiz ve doğru bir şekilde girerek hem
                                                işletmenize hem de müşterilerinize değer katın.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-lg-6 col-md-12">
                                    <div className="card">
                                        <div className="body">
                                            <h6>Servis Bilgileri</h6>
                                            <div className="form-group">
                                                <select name="vehicleData.branch_id" id='branch_id'
                                                    className="form-control border-danger"
                                                    onChange={this.handleChange}>
                                                    <option value="">Şube Seçiniz *</option>
                                                    {branches && (branches.map(branch => (
                                                        <option key={branch.id}
                                                            value={branch.id}>{branch.name}</option>
                                                    )))}

                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <select name="operationData.assigned_employee_id"
                                                    id='assigned_employee_id'
                                                    className="form-control border-danger"
                                                    onChange={this.handleChange}>
                                                    <option value="">Personel Seçiniz *</option>
                                                    {employes && (employes.map(employe => (
                                                        <option key={employe.id}
                                                            value={employe.id}>{employe.name} {employe.surname}</option>
                                                    )))}
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <select name="operationData.operation_type_id"
                                                    id='operation_type_id'
                                                    className="form-control border-danger"
                                                    onChange={this.handleChange}>
                                                    <option value="">Servis Tipi Seçiniz *</option>
                                                    {types && (types.map(type => (
                                                        <option key={type.id} value={type.id}>{type.name}</option>
                                                    )))}

                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <select name="operationData.statu_id"
                                                    id='statu_id'
                                                    className="form-control border-danger"
                                                    onChange={this.handleChange}>
                                                    <option value="">Servis Durumu Seçiniz *</option>
                                                    {status && status.map((statu) => (
                                                        <option key={statu.id} value={statu.id}>{statu.name}
                                                        </option>
                                                    ))}

                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <textarea name="operationData.description"
                                                    id='description' className="form-control textarea-height"
                                                    placeholder="Servis Açıklaması"
                                                    onChange={this.handleChange}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="card">
                                        <div className="body">
                                            <h6>Müşteri Bilgileri <small style={{ color: "red" }}>Sadece yeni müşteri
                                                için formu doldurun.Müşteri Kayıtlı ise
                                                lütfen müşteri seçiniz.</small></h6>

                                            <div className="form-group">
                                                <select name="customerData.customer_id" id="customer_id"
                                                    className="form-control"
                                                    onChange={this.handleChange}>
                                                    <option value="">Müşteri Seçiniz</option>
                                                    {customers && customers.map((customer) => (
                                                        <option key={customer.id} value={customer.id}>
                                                            {customer.name + ' ' + customer.surname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <input name="customerData.name"
                                                    id="name"
                                                    className="form-control border-danger"
                                                    placeholder="Ad *"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="customerData.surname"
                                                    id="surname"
                                                    className="form-control border-danger"
                                                    placeholder="Soyad *"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="customerData.phone"
                                                    id="phone"
                                                    className="form-control"
                                                    placeholder="Telefon"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="customerData.email"
                                                    id="email"
                                                    className="form-control"
                                                    placeholder="Email adresi"
                                                    type="email"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <textarea name="customerData.address"
                                                    id='address'
                                                    className="form-control"
                                                    placeholder="Adres"
                                                    onChange={this.handleChange}>
                                                </textarea>
                                            </div>
                                            {pDataloading ? (
                                                <div className="form-group text-center">
                                                    <button className="btn btn-outline-primary btn-block"
                                                        disabled={true}
                                                        style={{ textAlign: "-webkit-center" }}>
                                                        Müşteri kontrol ediliyor...<ReactLoading type="spin" width={'24px'}
                                                            height={'24px'}
                                                            color="#268bd2"></ReactLoading>
                                                    </button>
                                                </div>
                                            ) : ""}
                                            {
                                                !isCustomerHasPID ? (
                                                    <div className="form-group text-center">
                                                        <div className="fancy-checkbox">
                                                            <label htmlFor="save_parasut"
                                                                className="font-weight-bold text-cyan">

                                                                <input
                                                                    name="customerData.save_parasut"
                                                                    id="save_parasut"
                                                                    type="checkbox"
                                                                    checked={this.state.formData.save_parasut}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <span>Müşteriyi Paraşüt'e Kaydet</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="form-group text-center">
                                                        <label htmlFor="save_parasut"
                                                            className="font-weight-bold text-cyan text-center">
                                                            <span>Müşteri Paraşütte Kayıtlı</span>
                                                        </label>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="card">

                                        <div className="body">
                                            <button type="button" title="Resim ile temel araç bilgileri"
                                                className="btn btn-outline-info float-right mb-2"
                                                onClick={this.handleButtonClick}>
                                                <i className="fa fa-camera"></i>
                                            </button>
                                            <h6>Araç Bilgileri <small style={{ color: "red" }}> - Sadece yeni araç için
                                                formu doldurunuz. Araç kayıtlı ise lütfen araç seçiniz.</small></h6>

                                            <input
                                                type="file"
                                                ref={this.fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={this.handleFileChange}
                                            />
                                            <div className="form-group">
                                                <select name="vehicleData.vehicle_id" id="vehicle_id"
                                                    className="form-control"
                                                    onChange={this.handleChange}>
                                                    <option value="">Araç Seçiniz</option>
                                                    {vehicles && vehicles.map((vehicle) => (
                                                        <option key={vehicle.id} value={vehicle.id}>
                                                            {vehicle.brand?.name || " " + vehicle.model?.name || ""}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.plate"
                                                    id="plate"
                                                    className="form-control border-danger"
                                                    placeholder="Plaka *"
                                                    type="text"
                                                    value={this.state.formData.vehicleData.plate}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <Select
                                                    className="border-danger"
                                                    value={selectedBrand}
                                                    onChange={this.handleBrandChange}
                                                    options={brands}
                                                    placeholder="Marka Seçin"
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            borderColor: state.isFocused ? 'red' : 'red',
                                                            boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                            '&:hover': { borderColor: 'red' }
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <Select
                                                    className="border-danger"
                                                    value={selectedModel}
                                                    onChange={this.handleModelChange}
                                                    options={models}
                                                    placeholder="Model Seçin"
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            borderColor: state.isFocused ? 'red' : 'red',
                                                            boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                            '&:hover': { borderColor: 'red' }
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.year"
                                                    id="year"
                                                    className="form-control border-danger"
                                                    placeholder="Model Yılı *"
                                                    type="number"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <select name="vehicleData.gear_type" id='gear_type'
                                                    className="form-control"
                                                    onChange={this.handleChange}>
                                                    <option value="">Vites Tipi Seçiniz</option>
                                                    <option value="otomatik">Otomatik</option>
                                                    <option value="manuel">Manuel</option>

                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.package_name"
                                                    id="package_name"
                                                    className="form-control"
                                                    placeholder="Paket Adı"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="maintenance_date"
                                                    className="date-placeholder text-cyan">
                                                    Bakım tarihi
                                                </label>
                                                <input name="vehicleDates.maintenance_date"
                                                    id="maintenance_date"
                                                    className="form-control"
                                                    type="date"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="inspection_date"
                                                    className="date-placeholder text-cyan">
                                                    Muayene tarihi
                                                </label>
                                                <input name="vehicleDates.inspection_date"
                                                    id="inspection_date"
                                                    className="form-control"
                                                    type="date"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <textarea name="vehicleData.details"
                                                    id="details"
                                                    className="form-control"
                                                    placeholder="Araç detayları"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="card">
                                        <div className="body">
                                            <h6>&nbsp;</h6>
                                            <div className="form-group">
                                                <input name="vehicleData.engine_no"
                                                    id="engine_no"
                                                    className="form-control"
                                                    placeholder="Motor No"
                                                    type="number"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.engine_size"
                                                    id="engine_size"
                                                    className="form-control"
                                                    placeholder="Motor Hacmi"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.km"
                                                    id="km"
                                                    className="form-control border-danger"
                                                    placeholder="Km *"
                                                    type="number"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.chassis_no"
                                                    id="chassis_no"
                                                    className="form-control border-danger"
                                                    placeholder="Şase No *"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input name="vehicleData.key_no"
                                                    id="key_no"
                                                    className="form-control"
                                                    placeholder="Anahtar No"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="next_maintenance_date"
                                                    className="date-placeholder text-cyan">
                                                    Sonraki bakım tarihi
                                                </label>
                                                <input name="vehicleDates.next_maintenance_date"
                                                    id="next_maintenance_date"
                                                    className="form-control"
                                                    type="date"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="next_inspection"
                                                    className="date-placeholder text-cyan">
                                                    Sonraki muayene tarihi
                                                </label>
                                                <input name="vehicleDates.next_inspection_date"
                                                    id="next_inspection_date"
                                                    className="form-control"
                                                    type="date"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input name="vehicleData.vehicleImages"
                                                    id="vehicleImages"
                                                    className="form-control"
                                                    type="file"
                                                    multiple={true}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 d-flex justify-content-center">
                                    <div className="card">
                                        <div className="body">
                                            <div className="col-lg-6 mx-auto">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block"
                                                        disabled={true}
                                                        style={{ textAlign: "-webkit-center" }}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                            height={'24px'}
                                                            color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-outline-primary btn-block" type="submit">
                                                        Kaydet
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
            ;
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withRouter(connect(mapStateToProps, {})(ServiceAdd));
